import React from 'react';
import { Box, Typography, Input, Button } from '@mui/material';

export const FileUploadBlock = ({ setting, onValueChange, logoPreview, onLogoUpload }) => {
    return (
        <Box display="flex" alignItems="center">
            {logoPreview ? (
                <img
                    src={logoPreview}
                    alt="Logo Preview"
                    style={{ width: "100px", height: "auto", marginRight: 16 }}
                />
            ) : (
                <Typography variant="caption">
                    No logo uploaded
                </Typography>
            )}
            <Input
                accept="image/*"
                id="logo-upload"
                type="file"
                style={{ display: "none" }}
                onChange={onLogoUpload}
            />
            <label htmlFor="logo-upload">
                <Button disabled={!setting.is_active} variant="contained" component="span">
                    Upload Logo
                </Button>
            </label>
        </Box>
    );
};
